import React, { useEffect } from 'react';
import useScreenSize from '../../hooks/useScreenSize';
import AdManagerBanner from './AdManagerBanner';
import Banner from './index';
import { useGPTScript } from '../../hooks/useGPTScript';
import { TargetedBannerIds } from '../../types';

const BannersContainer: React.FC<{
  isBackgroundBanner?: boolean;
  isBanner?: boolean;
}> = ({ isBanner, isBackgroundBanner }) => {
  const { isSmall, isLarge } = useScreenSize();
  useGPTScript(isLarge || (isBanner && !isSmall));

  useEffect(() => {
    const bgLeft = document.querySelector('.lotriver-bg-left');
    const bgRight = document.querySelector('.lotriver-bg-right');

    if (bgLeft) {
      bgLeft.style.display = isBackgroundBanner ? 'block' : 'none';
    }

    if (bgRight) {
      bgRight.style.display = isBackgroundBanner ? 'block' : 'none';
    }
  }, [isBackgroundBanner]);

  return (
    <>
      {isLarge && isBackgroundBanner && (
        <>
          <div id={TargetedBannerIds.bg} />
          <div id={TargetedBannerIds.catfish} />
          <AdManagerBanner bannerName="bg" />
          <AdManagerBanner bannerName="catfish" />
        </>
      )}
      {isBanner && !isSmall && (
        <>
          <Banner
            key="js-lotriver-desk-top-banner"
            containerClassName={'js-lotriver-desk-top-banner'}
            containerId={'js-lotriver-desk-top-banner'}
            sid={'220686'}
            bn={'1'}
            arCn={1}
          />
          <AdManagerBanner bannerName="deskTop" />
        </>
      )}
    </>
  );
};

export default BannersContainer;
